<template>
  <div class="noprint flex items-center justify-between p-4 max-w-3xl bg-green-400 rounded">
    <div class="flex items-center">
      <InformationCircleIcon class="flex-shrink-0 mr-2 w-4 h-4" />
      <div class="text-green-800 text-sm font-medium">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { InformationCircleIcon } from '@heroicons/vue/24/outline'

export default {
  components: {
    InformationCircleIcon,
  },
}
</script>
